import { addUtcDays, endOfUtcDayIso, startOfUtcDayIso } from '../../common/helpers/dateFns.helper';

export const getDefaultDemandRange = (): [fromDate: string, toDate: string] => {
    const fromDate = startOfUtcDayIso(new Date());
    const toDate = endOfUtcDayIso(addUtcDays(new Date(), 120));
    return [fromDate, toDate];
};
